<div class="modal-header">
    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="closeModal()"></button>
  </div>
  <div class="modal-body">
    <figure class="figure-container">
      <img [src]="images[0]" alt="Imagen modal" class="modal-image">
    </figure>
  </div>
  